import { ChangeDetectionStrategy, Component, computed, inject, input, ViewEncapsulation } from '@angular/core';
import { ImageUrlTransformPipe } from '../../pipes';
import { ActivatedRoute } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { KameleoonService } from '@seven1/angular/kameleoon';
import { TailwindService } from '@seven1/angular-storyblok/tailwind';
import { IDecoratedSectionBlok } from './decorated-section.model';
import { NgClass } from '@angular/common';
import { CmsComponent } from '@seven1/angular-storyblok-cms';

@Component({
    selector: 'app-decorated-section-container',
    imports: [ImageUrlTransformPipe, NgClass, CmsComponent],
    templateUrl: './decorated-section-container.component.html',
    styleUrl: './decorated-section-container.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        '[class]': 'getDisplayClasses()',
    },
})
export class DecoratedSectionContainerComponent {
    private _tailwind = inject(TailwindService);
    readonly baseClass: string = 'app-decorated-section';
    private _kameleoonService = inject(KameleoonService);
    private route = inject(ActivatedRoute);
    queryParams = toSignal(this.route.queryParamMap);

    block = input.required<IDecoratedSectionBlok>();

    visible = computed(() => {
        return this._kameleoonService.visible(this.queryParams(), this.block());
    });

    getOuterClasses = computed(() => {
        return this._tailwind.getSpacingClasses(this.block());
    });

    getBgSizeClass = computed<string[]>(() => {
        const block = this.block();
        const res = this.getDecorationColorClasses();
        if (block.imagePosition === 'right') {
            if (block.imageInside) {
                res.push('md:left-[60%]', 'min-[1920px]:left-[calc(50vw+160px)]');
            } else {
                res.push('md:left-[70%]', 'min-[1920px]:left-[calc(50vw+360px)]');
            }
        } else {
            if (block.imageInside) {
                res.push('md:right-[60%]', 'min-[1920px]:right-[calc(50vw+160px)]');
            } else {
                res.push('md:right-[70%]', 'min-[1920px]:right-[calc(50vw+360px)]');
            }
        }
        return res;
    });

    getDecorationColorClasses = computed(() => {
        return this._tailwind.getBackgroundColorClasses(this.block());
    });

    getGapClasses = computed(() => {
        return this._tailwind.getGapClasses(this.block());
    });

    getDisplayClasses = computed(() => {
        return this._tailwind.getDisplayClasses(this.block());
    });

    getImageClasses = computed(() => {
        const block = this.block();
        return this._tailwind.getSizeClasses({
            maxWidth: block.imageWidth,
            maxWidthTablet: block.imageWidthTablet,
            maxWidthDesktop: block.imageWidthDesktop,
        });
    });
}
